import { render, staticRenderFns } from "./recycleBin.vue?vue&type=template&id=55e80a3a&scoped=true&"
import script from "./recycleBin.vue?vue&type=script&lang=js&"
export * from "./recycleBin.vue?vue&type=script&lang=js&"
import style0 from "./recycleBin.vue?vue&type=style&index=0&id=55e80a3a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e80a3a",
  null
  
)

export default component.exports